import { Component, OnInit, ViewChild } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { GridMenuItem } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid-menu/grid-menu-item';
import { GridComponent, RowClass } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid.component';
import { IGridColumn } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-column';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { ApiAdminAppUser } from '../../../api/endpoints/ApiAdminAppUser';
import { AppUserDto } from '../../../api/dtos/AppUserDto';
import { AppUserFiltersDto } from '../../../api/dtos/AppUserFiltersDto';
import { AppUserCreateComponent } from './app-user-create.component';
import { AppUserEditComponent } from './app-user-edit.component';
import { AppUserRolesComponent } from './app-user-roles.component';
import { HttpApiRequestOptions } from '../../../api/endpoints/HttpApiRequestOptions';
import { Icons } from '../../../../../../libs/utils/ng-shared-components/src/lib/icon/icons';
import { PagedSearchDto } from '../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';
import { IGridFilter } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-filter';
import { FilterType } from '../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/filter-type';

@Component({
  standalone: false,
  selector: 'mf-app-user-grid',
  templateUrl: './app-user-grid.component.html',
  styleUrls: ['./app-user-grid.component.scss'],
})
export class AppUserGridComponent implements OnInit {
  constructor(
    private _apiAdminAppUser: ApiAdminAppUser,
    private _modalService: ModalService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.filters = new AppUserFiltersDto();
    this.filters.includeInactive = true;
  }

  @ViewChild('grid')
  grid: GridComponent;
  user: AppUserDto;
  filters: AppUserFiltersDto;

  globalFilters: IGridFilter[] = [
    {
      header: 'Incluir Inactivas',
      propertyName: nameof<AppUserFiltersDto>((b) => b.includeInactive),
      type: FilterType.Boolean,
    },
  ];

  columns: IGridColumn<AppUserDto>[] = [
    { field: nameof<AppUserDto>((p) => p.naturalPerson.email), header: 'Nombre', width: 60 },
    { field: nameof<AppUserDto>((p) => p.naturalPerson.firstName), header: 'Nombre', width: 20 },
    { field: nameof<AppUserDto>((p) => p.naturalPerson.lastName), header: 'Nombre', width: 20 },
  ];

  menuItems: GridMenuItem[] = [
    {
      label: 'Editar',
      icon: Icons.edit,
      onClick: (userDto: AppUserDto) => {
        this._modalService.openLargeModal(AppUserEditComponent, {
          openData: userDto.id,
          onCloseSuccess: (userDto: AppUserDto) => {
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Roles',
      icon: Icons.manageAccounts,
      onClick: (userDto: AppUserDto) => {
        this._modalService.openNormalModal(AppUserRolesComponent, {
          openData: userDto.id,
          onCloseSuccess: () => {
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Inactivar',
      icon: Icons.delete,
      hide: (userDto: AppUserDto) => userDto.inactive,
      onClick: async (userDto: AppUserDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: 'Esta seguro que desea inactivar al usuario ' + userDto.naturalPerson.email + '?',
          },
          onCloseSuccess: async () => {
            await this._apiAdminAppUser.delete(userDto.id);
            this._notificationService.showSuccess('El usuario ha sido inactivado correctamente');
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Reactivar',
      icon: Icons.check,
      hide: (userDto: AppUserDto) => !userDto.inactive,
      onClick: (userDto: AppUserDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: 'Esta seguro que desea volver a activar al usuario ' + userDto.naturalPerson.email + '?',
          },
          onCloseSuccess: async () => {
            await this._apiAdminAppUser.reactivate(userDto.id);
            this._notificationService.showSuccess('El usuario ha sido reactivado correctamente');
            this.grid.reloadPage();
          },
        });
      },
    },
  ];

  getRowClass(row: any) {
    if (!row.item.inactive) {
      return null;
    }
    return RowClass.Inactive;
  }

  apiEndpoint = (search: PagedSearchDto<AppUserFiltersDto>, httpApiRequestOptions: HttpApiRequestOptions) =>
    this._apiAdminAppUser.getPaged(search, httpApiRequestOptions);

  openNewUserPopup() {
    this._modalService.openLargeModal(AppUserCreateComponent, {
      onCloseSuccess: () => {
        this.grid.reloadPage();
      },
    });
  }
}
